import {ChangeDetectionStrategy, Component} from '@angular/core';
import {MainMenuDropdownComponent} from '../main-menu-dropdown/main-menu-dropdown.component';

@Component({
    selector: 'ul[static-main-menu]',
    templateUrl: '../main-menu-dropdown/main-menu-dropdown.component.html',
    styleUrls: ['./main-menu-static.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MainMenuStaticComponent extends MainMenuDropdownComponent {

    public override createOverlay(): void {
        // Overwrite parent method
    }

    public override initPopper(): void {
        // Overwrite parent method
    }

    public override destroyPopper(): void {
        // Overwrite parent method
    }
}
